module.exports = __webpack_public_path__ + "img/nota-codigo-papelia.f565a76a.png";